import React, { useState } from "react";
import { Form, Row, Col, Input, Select, Divider, Spin } from "antd";
import ModalWrapper from "../../../modal/ModelWrapper";
import styled from "styled-components";
import recording from "../../../../services/recording";
import { notify } from "../../../../utils/helper";
import { CustomButton, CustomSecondaryButton } from "../styled";

const FormContainer = styled.div`
  max-height: 60vh;
  overflow-y: auto;
  overflow-x: hidden;
  padding-right: 10px;
  width: 100%;

  /* Scrollbar styling */
  &::-webkit-scrollbar {
    width: 8px;
  }

  /* &::-webkit-scrollbar-track {
    background:rgb(138, 136, 136);
    border-radius: 10px;
  } */

  &::-webkit-scrollbar-thumb {
    background: #c1c1c1;
    border-radius: 10px;
  }

  &::-webkit-scrollbar-thumb:hover {
    background: #a8a8a8;
  }
`;

const SectionTitle = styled.h4`
  font-size: 16px;
  font-weight: 600;
  color: var(--primary-text-color);
  margin-bottom: 5px;
`;

const SpinContainer = styled.div`
  .ant-spin-dot-item {
    background-color: #fff;
  }
`;


const SaveRecordingModel = ({ isOpen, setOpen, audioUrl, fetchAudioFiles, scriptId, setAudioUrl}) => {
  const [isLoading, setIsLoading] = useState(false);

  const saveRecording = async(values) => {
    try {
      setIsLoading(true)
    const response = await fetch(audioUrl);
    const blob = await response.blob();
      const formData = new FormData();
      formData.append("name", values?.name);
      formData.append("file", blob);
      // formData.append("script", scriptId)

      const res= await recording.saveRecording(formData)
      if(res?.status === 201){
        notify('success',"Recording saved successfully!")
        fetchAudioFiles()
        setOpen(false)
        setAudioUrl(null)
      }
      setIsLoading(false)
    }
    catch(err) {
      setIsLoading(false)
    }
  }
  return (
    <ModalWrapper
      show={isOpen}
      setShow={setOpen}
      title={
        <div className="row-flex flex-column">
          <h3 className="font-18 font-semibold text-primary">
            Save Recording
          </h3>
        </div>
      }
      footer={null}
      width={600}
      keyClose={false}
    >
      <Form
        layout="vertical"
        onFinish={saveRecording}
        requiredMark="optional"
      >
        <FormContainer>
          <Row gutter={[24, 16]}>
            <Col span={24}>
              <Form.Item
                name="name"
                label="Recording name"
                rules={[
                  { required: true, message: "Please input the recording name!" },
                ]}
              >
                <Input placeholder="Name of Recoding" size="large" />
              </Form.Item>
            </Col>

          </Row>
        </FormContainer>

        <Divider style={{ margin: "20px 0" }} />

       <SpinContainer>
          <Row>
            <Col span={24} className="d-flex justify-end gap-12">
              <CustomSecondaryButton onClick={() => setOpen(false)}>
                Cancel
              </CustomSecondaryButton>
              <CustomButton disabled={isLoading} htmlType="submit">
                {isLoading ? "Saving..." : "Save Recording"}
                <Spin spinning={isLoading} className="d-flex justify-content-center ml-5" size="small" />
              </CustomButton>
            </Col>
          </Row>
        </SpinContainer>
      </Form>
    </ModalWrapper>
  );
};

export default SaveRecordingModel;
